export default __webpack_public_path__ + "static/media/work-sans-v11-latin-regular.655d0fe0.woff";